import Vue       from 'vue'
import Vuex      from 'vuex'
import vueCookie from 'vue-cookie'

Vue.use(Vuex)
Vue.use(vueCookie)

const defaultUserData = {
  logged:                  false,
  languageId:              null,
  languageCode:            null,
  email:                   null,
  phone:                   null,
  name:                    null,
  id:                      null,
  identity:                {
    accessToken: null,
    tokenType:   null,
    appName:     null
  },
  headerNotificationTimer: null
}

export default new Vuex.Store(
  {
    state: {
      user:        null,
      urlAppName:  localStorage.getItem('appName') ? localStorage.getItem(
        'appName') : null,
      languages:   [],
      gridData:    [],
      gridEditTag: false,
      rowData:     undefined,
      hpRedirect:  null,
      eventId: undefined
    },

    mutations: {

      /**
       *
       * @param state
       * @param args
       */
      setUser (state, args) {
        if (!args.hasOwnProperty('response')) {
          state.user = args
          return
        }

        let response   = args.response
        let expiration = args.hasOwnProperty('cookieExpiration')
          ? args.cookieExpiration
          : {}

        let user = state.user ? state.user : defaultUserData

        user.logged       = true
        user.languageId   = response.iDtLanguage
        user.languageCode = response.lang
        user.email        = response.email
        user.phone        = response.phone
        user.name         = response.userName
        user.id           = response.id

        user.identity.accessToken = response.access_token
        user.identity.tokenType   = response.token_type
        user.identity.appName     = response.appName

        Vue.cookie.set('user', JSON.stringify(user), expiration)
        Vue.prototype.$user = user

        state.user = user
      },

      /**
       *
       * @param state
       */
      logout (state) {
        let defUs = {
          logged:       false,
          languageId:   null,
          languageCode: null,
          email:        null,
          phone:        null,
          name:         null,
          id:           null,
          identity:     {
            accessToken: null,
            tokenType:   null,
            appName:     null
          }
        }

        Vue.cookie.set('user', JSON.stringify(defUs))
        state.user = defUs
      },

      /**
       *
       * @param state
       * @param args
       */
      setUrlAppName (state, args) {
        let appName    = args.appName
        let expiration = args.hasOwnProperty('cookieExpiration')
          ? args.cookieExpiration
          : {}
        Vue.cookie.set('appName', appName, expiration)
        state.urlAppName = appName
      },

      /**
       *
       * @param state
       * @param languages
       */
      setLanguages (state, languages) {
        state.languages = languages
      },

      setHpRedirect(state, value) {
        state.hpRedirect = value
      },

      /**
       *
       * @param state
       * @param data
       */
      setGridData (state, data) {
        if (data === null) {
          state.gridData = []

          return
        }

        if (!data.hasOwnProperty('lastData')) {
          throw new Error('Property lastData not set!')
        }

        if (!data.hasOwnProperty('idStructure')) {
          throw new Error('Property idStructure not set!')
        }

        if (!data.hasOwnProperty('lastOffset')) {
          throw new Error('Property lastOffset not set!')
        }

        if (!data.hasOwnProperty('lastTopPosition')) {
          throw new Error('Property lastTopPosition not set!')
        }

        if (!data.hasOwnProperty('searchedText')) {
          throw new Error('Property searchedText not set!')
        }

        for (let i = 0; i < state.gridData.length; i++) {
          let item = state.gridData[i]

          if (item.lastPage + '%' + item.idStructure === data.lastPage + '%' +
            data.idStructure) {
            state.gridData[i] = data

            return
          }
        }

        state.gridData.push(data)
      },

      /**
       *
       * @param state
       * @param row
       */
      setGridEditTag (state, row) {
        state.gridEditTag = row
      },

      /**
       *
       * @param state
       * @param row
       */
      setRowData (state, row) {
        state.rowData = row
      },

      /**
       *
       * @param state
       * @param timer
       */
      setHeaderNotificationTimer (state, timer) {
        state.headerNotificationTimer = timer
      },

      setEventId(state, eventId) {
        state.eventId = eventId
      },
    },

    getters: {

      /**
       *
       * @param state
       * @return {*}
       */
      user (state) {
        if (state.user) {
          return state.user
        }

        let cookieUser = Vue.cookie.get('user')

        if (cookieUser) {
          try {
            cookieUser = JSON.parse(cookieUser)
          }
          catch (error) {
            return defaultUserData
          }

          state.user = cookieUser
          return cookieUser
        }

        return defaultUserData
      },

      /**
       *
       * @param state
       * @return {any | *}
       */
      urlAppName (state) {
        return state.urlAppName
      },

      /**
       *
       * @param state
       * @return {Array|*}
       */
      languages (state) {
        return state.languages
      },

      hpRedirect(state) {
        return state.hpRedirect
      },

      /**
       *
       * @param state
       * @return {null|*}
       */
      getGridData (state) {
        return (source) => {

          for (let i = 0; i < state.gridData.length; i++) {
            let item = state.gridData[i]

            if (item.lastPage + '%' + item.idStructure === source) {
              state.gridData.splice(i, 1)

              return item
            }
          }

          return null
        }
      },

      /**
       *
       * @param state
       * @return {undefined|*}
       */
      getGridEditTag (state) {
        return state.gridEditTag
      },

      /**
       *
       * @param state
       * @return {undefined|*}
       */
      getRowData (state) {
        return state.rowData
      },

      /**
       *
       * @param state
       * @return {*|null}
       */
      getHeaderNotificationTimer (state) {
        return state.headerNotificationTimer
      },

      getEventId(state){
        return state.eventId
      },
    }

  })
